import { MirageForm } from '@/features/factory/subfactories/MirageForm'

/** Sub-route /factory/mirage — wraps the form component. */
export function MiragePage() {
  return <MirageForm />
}
